<template>
    <v-select   :value="value" 
                :options="countries"
                :filter="vSelectSearch"
                class="hg-select" 
                :reduce="s => s.value"
                @input="$emit('input', $event)"
                :disabled="!Array.isArray(countries)"
                required>
        <template slot="selected-option" slot-scope="option">
            <img :src="'/images/flags/' + option.value.toLowerCase() + '.svg'" v-if="option && option.value" style="width:24px"/>&nbsp;
            <span class="text" v-i18n="option.text" />
        </template>
        <template slot="option" slot-scope="option">
            <img :src="'/images/flags/' + option.value.toLowerCase() + '.svg'" v-if="option && option.value" style="width:24px"/>&nbsp;
            <span   class="text" v-i18n="option.text" />
        </template>
    </v-select>
</template>
<script>
import {COUNTRIES} from "morpheos.hisport.vueplugin";
export default {
    props:["value"],
    data(){
        return {
            countries: COUNTRIES.map(function(c){
                            return {
                                value: c.abbreviation.toUpperCase(),
                                text: c.country
                            }
                        })
        }
    },
    methods:{
        vSelectSearch(options, search){
            return search.length?options.filter(function(x){
                return x && x.text && x.text.toLowerCase().indexOf(search.toLowerCase())>=0
            }):options;
        }
    }
}
</script>
